import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        wrapper: {
            display: 'flex',
            alignItems: 'center',
        },
        icon: {
            paddingLeft: theme.spacing(1),
        },
    }
})

export default useStyles
